var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikeTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.33334H4C2.89333 1.33334 2 2.22001 2 3.31334V10.5867C2 11.68 2.89333 12.5667 4 12.5667H4.50667C5.04 12.5667 5.54667 12.7733 5.92 13.1467L7.06 14.2733C7.58 14.7867 8.42667 14.7867 8.94667 14.2733L10.0867 13.1467C10.46 12.7733 10.9733 12.5667 11.5 12.5667H12C13.1067 12.5667 14 11.68 14 10.5867V3.31334C14 2.22001 13.1067 1.33334 12 1.33334ZM11.12 7.00001L10.34 9.37334C10.24 9.76668 9.82 10.0867 9.39333 10.0867H8.16C7.94667 10.0867 7.64667 10.0133 7.51333 9.88001L6.53333 9.11334C6.51333 9.54001 6.32 9.72001 5.84667 9.72001H5.52667C5.03333 9.72001 4.83333 9.52668 4.83333 9.06001V5.88001C4.83333 5.41334 5.03333 5.22001 5.52667 5.22001H5.85333C6.34667 5.22001 6.54667 5.41334 6.54667 5.88001V6.12001L7.84 4.20001C7.97333 3.99334 8.31333 3.84668 8.6 3.96001C8.91333 4.06668 9.11333 4.41334 9.04667 4.72001L8.88667 5.76001C8.86667 5.84668 8.88667 5.94001 8.94667 6.00001C9 6.06001 9.08 6.10001 9.16667 6.10001H10.4667C10.72 6.10001 10.9333 6.20001 11.06 6.38001C11.18 6.55334 11.2 6.77334 11.12 7.00001Z",
    fill: "url(#paint0_linear_1612_295)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1612_295",
    x1: 2.04286,
    y1: 7.99541,
    x2: 14.0022,
    y2: 7.96398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431DAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE6DFE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeTag);
export default __webpack_public_path__ + "static/media/like-tag.7290295cd47edd3eff6c619abc67c340.svg";
export { ForwardRef as ReactComponent };